export const optimizeImageFile = (file) => {
        if (!file || !file.type.startsWith("image/")) {
                return Promise.resolve(file);
        }

        return new Promise((resolve, reject) => {
                const reader = new FileReader();

                reader.onload = (event) => {
                        const img = new Image();

                        img.onload = () => {
                                const canvas = document.createElement("canvas");
                                const ctx = canvas.getContext("2d");

                                if (!ctx) {
                                        resolve(file);
                                        return;
                                }

                                let { width, height } = img;
                                const maxSize = 1280;

                                if (width > height && width > maxSize) {
                                        height = (height * maxSize) / width;
                                        width = maxSize;
                                } else if (height > maxSize) {
                                        width = (width * maxSize) / height;
                                        height = maxSize;
                                }

                                canvas.width = width;
                                canvas.height = height;
                                ctx.drawImage(img, 0, 0, width, height);

                                const outputType = file.type === "image/png" ? "image/png" : "image/jpeg";
                                const quality = outputType === "image/png" ? 0.92 : 0.75;

                                canvas.toBlob(
                                        (blob) => {
                                                if (!blob) {
                                                        resolve(file);
                                                        return;
                                                }

                                                const optimizedFile = new File([blob], file.name, {
                                                        type: outputType,
                                                        lastModified: Date.now(),
                                                });

                                                resolve(optimizedFile);
                                        },
                                        outputType,
                                        quality
                                );
                        };

                        img.onerror = () => resolve(file);
                        img.src = event.target?.result;
                };

                reader.onerror = () => resolve(file);
                reader.readAsDataURL(file);
        });
};
